module.exports = __webpack_public_path__ + "static/media/diagram-figure.34b4bffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/neva/diagram-figure.png
// module id = 352
// module chunks = 0